<!--
Author:
Create Time: 2020-04-13 09:22:08
Description: 人口信息选择框
-->
<template>
  <div class="com-populregister-select">
      <span>
          <el-input
            placeholder
            v-model="label"
            @focus="handleInputClick"
            :disabled="disabled"
            data-ignore-clearable="true"
            data-ignore-at-clear="handleClear"
            :title="label"
          ></el-input>
      </span>

      <partyMemberRegisterRef
        ref="partyMemberRegisterRef"
        :visible="ispartyMemberRegisterRefVisible"
        @confirm="handlepartyMemberRegisterRefConfirm"
        :multiple="multiple"
        @cancel="handlepartyMemberRegisterRefCancel"
        append-to-body
        width="65%"
      />
  </div>
</template>

<script>
export default {
  name: 'partyMemberRegisterSelect',
  props: {
      value: {
          type: [String, Array, undefined],
          default: () => ''
      },
      label: {
          type: String,
          default: () => ''
      },
      disabled: {
          type: Boolean,
          default: () => false
      },
  },
  data () {
    return {
        ispartyMemberRegisterRefVisible: false,
    }
  },
  computed: {
      multiple() {
          return Array.isArray(this.value);
      },
  },
  methods: {
      handleInputClick() {
          this.ispartyMemberRegisterRefVisible = true;
      },
      handleClear() {},
      handlepartyMemberRegisterRefConfirm(value) {
          let val = Array.isArray(value) ? value.map(o => o.id) : value.id;
          this.$emit('update:value', val, value);
          this.$emit('change', val, value);
          this.$emit('input', val, value);
          this.ispartyMemberRegisterRefVisible = false;
      },
      handlepartyMemberRegisterRefCancel() {
          this.ispartyMemberRegisterRefVisible = false;
      },
  }
}
</script>

<style scoped lang="less">
.com-populregister-select {
    display: inline-block;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/partyMemberRegister/partyMemberRegisterSelect.vue